module.exports = __webpack_public_path__ + "static/media/union-3.87fdd495.jpg";